import React, { useState, useEffect } from 'react';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
import './GifPicker.css';

// Use a hardcoded API key for now - we can move this to env later
const GIPHY_API_KEY = 'GlVGYHkr3WSBnllca54iNt0yFbjz7L65';
const gf = new GiphyFetch(GIPHY_API_KEY);

interface GifPickerProps {
  onGifSelect: (gifUrl: string) => void;
  onClose: () => void;
}

export function GifPicker({ onGifSelect, onClose }: GifPickerProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [width, setWidth] = useState(window.innerWidth < 768 ? 300 : 400);
  const [columns, setColumns] = useState(window.innerWidth < 768 ? 2 : 3);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth < 768 ? 300 : 400);
      setColumns(window.innerWidth < 768 ? 2 : 3);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchGifs = (offset: number) => {
    return searchQuery
      ? gf.search(searchQuery, { offset, limit: 10 })
      : gf.trending({ offset, limit: 10 });
  };

  return (
    <div className="h-full flex flex-col">
      <div className="sticky top-0 bg-white dark:bg-gray-800 z-10 px-4 py-3 border-b dark:border-gray-700">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold dark:text-white">Select a GIF</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            ✕
          </button>
        </div>
        <input
          type="text"
          placeholder="Search GIFs..."
          className="w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <div className="giphy-grid-wrapper min-h-[300px]">
          <Grid
            onGifClick={(gif, e) => {
              e.preventDefault();
              onGifSelect(gif.images.original.url);
              onClose();
            }}
            fetchGifs={fetchGifs}
            width={width}
            columns={columns}
            gutter={6}
            noLink={true}
            key={searchQuery}
          />
        </div>
      </div>
    </div>
  );
}
